// @flow
import React from "react";
import { connect } from "react-redux";

import { Translate, useI18n, withI18n } from "@quantum/i18n";
import { FiInfo as IconeHint } from "react-icons/fi";

import {
  Tooltip,
  TooltipArrow,
  TooltipReference,
  useTooltipState,
} from "reakit/Tooltip";

import { compose } from "ramda";

import SelectInput from "../../../comum/SelectInput";
import {
  type ActionCreator,
  selecionarFonteFidc,
  getFontesFidc,
  getFonteFidcSelecionada,
} from "../../../../state";
import { type Id, type FonteFidc } from "../../../../model";

type Prop = {
  listaFonteFidc: Array<FonteFidc>,
  fonteFidcSelecionada: Id,
  selecionarFonteFidc: ActionCreator,
};

function SelecaoFonteFidc({
  listaFonteFidc,
  fonteFidcSelecionada,
  selecionarFonteFidc,
}: Prop) {
  const { translate } = useI18n();
  const tooltip = useTooltipState();

  function handleFonteFidcSelecionada(id) {
    selecionarFonteFidc(id);
  }

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label ConfiguracaoMedida__label--hint">
        {
          <>
            <Translate>telas.label.fonte</Translate>
            <TooltipReference {...tooltip}>
              <IconeHint />
            </TooltipReference>
            <Tooltip {...tooltip} className="ConfiguracaoMedida__tooltip">
              <Translate>configuracaoRelatorio.hint.fonteFidc</Translate>
              <TooltipArrow {...tooltip} />
            </Tooltip>
          </>
        }
      </label>
      <SelectInput
        className="ConfiguracaoMedida__input-select"
        value={fonteFidcSelecionada}
        options={listaFonteFidc}
        placeholder={translate("configuracaoRelatorio.placeholderAjuste")}
        onChange={handleFonteFidcSelecionada}
        multiple={false}
        size={1}
        campoDescricao={"traducao"}
        searchable={false}
      />
    </div>
  );
}

export default compose(
  withI18n,
  connect(
    (state, { translate }) => ({
      listaFonteFidc: getFontesFidc(state).map(fonte => ({
        ...fonte,
        traducao: translate(fonte.chaveTraducao),
      })),
      fonteFidcSelecionada: getFonteFidcSelecionada(state),
    }),
    { selecionarFonteFidc }
  )
)(SelecaoFonteFidc);
